import React from 'react';

type State = {
    value    : number;
    position : number;
};

type LogSliderProps = {
    name     : string;
    input    : number;
    steps    : number;
    minValue : number;
    maxValue : number;

    onChange : (value : number) => void;
};

export class LogSliderComp extends React.Component<LogSliderProps, State> {

    maxLogValue : number;
    minLogValue : number;
    scale       : number;

    constructor(props: LogSliderProps) {
        super(props);
        this.minLogValue = Math.log(props.minValue);
        this.maxLogValue = Math.log(props.maxValue);
        this.scale       = (this.maxLogValue - this.minLogValue) / (props.steps);

        this.state = {
            position : this.getPositionFromValue(props.input),
            value    : props.input
        }
    }

    // Convert logarithmic value to slider position
    getPositionFromValue(value : number) : number
    {
        return Math.round((Math.log(value) - this.minLogValue) / this.scale);
    }

    getValueFromPosition(position : number) {
        return Math.exp(position * this.scale + this.minLogValue);
    }

    handleChange(e : React.ChangeEvent<HTMLInputElement>)
    {
        const pos          = parseInt(e.target.value);
        const value        = this.getValueFromPosition(pos);
        const expString    = value.toExponential(1);
        const roundedValue = Number(expString);

        this.setState({
            position : pos,
            value    : value
        });

        this.props.onChange(roundedValue);
    }

    render() {
        return (
          <>
          <label className="labelStyle" htmlFor="steps">Learning Rate</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <input
              style={{ flex: 1 }}
              id="steps"
              name="steps"
              type="range"
              min={0}
              max={this.props.steps}
              step={1}
              value={this.state.position}
              onChange={(e) => this.handleChange(e) }
            />
            <span style={{ minWidth: '2.5rem', textAlign: 'center', fontWeight: 'bold' }}>
              { this.state.value.toExponential(1).replace('e', 'E') }
            </span>
          </div>
          </>
        );
      }
}

